import { withI18n } from 'panda-i18n';
import { CnCascaderSelect as CnCascaderSelectView } from './cascader-select';
import locale from "../../locale";
import './styles/index.scss';
export var CnCascaderSelectV2 = withI18n(CnCascaderSelectView, {
    locale: locale,
});
